import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import lottoLogo from '../assets/images/lottologo.jpg';
import magic3Logo from '../assets/images/magic3.jpg';
import template4Logo from '../assets/images/template4logo.jpg';
dayjs.extend(customParseFormat);

export default function TicketTemplate1({
  transaction,
  displayName,
  userName,
}) {
  const bets = useMemo(() => {
    const sortedBets = [...transaction.bets].sort((a, b) => {
      if (a.drawTime !== b.drawTime)
        return a.drawTime.localeCompare(b.drawTime);
      const gameA = a.GameSetting?.name || a.gameName || '';
      const gameB = b.GameSetting?.name || b.gameName || '';
      return gameA.localeCompare(gameB);
    });
    return sortedBets;
  }, [transaction]);

  const drawId = dayjs(transaction.drawDate)
    .diff(dayjs('2025-04-12'), 'day')
    .toString()
    .padStart(7, '0');

  return (
    <div className='grid max-h-0 overflow-hidden'>
      <div
        id='print-ticket'
        className='w-[227px] text-[10px] flex flex-col gap-4 bg-white font-bitMatrix'
      >
        <div className='flex flex-col'>
          <div className='flex flex-col justify-between'>
            <div className='leading-tight'>
              <div className='flex justify-center items-center gap-1 w-full mb-1'>
                <img src={lottoLogo} className='h-[40px]' />
                <img src={magic3Logo} className=' h-[25px]' />
                <img src={template4Logo} className=' h-[40px]' />
              </div>
              <div>MAGIC 3 PREMIER</div>
              <div className='flex flex-col text-left'>
                <div className='flex'>
                  <span className='w-[50px] text-right mr-1'>Ref No:</span>
                  {dayjs(transaction.bets[0].createdAt).format('YYMMDD') +
                    new Date().getTime().toString()}
                </div>
                <div className='flex'>
                  <span className='w-[50px] text-right mr-1'>Draw:</span>
                  {dayjs(transaction.bets[0].createdAt).format('MMM DD, YYYY ')}
                  {dayjs(transaction.drawTime, 'HH:mm').format('h-A')}
                </div>
                <div className='flex'>
                  <span className='w-[50px] text-right mr-1'>Agent:</span>
                  {userName}
                </div>
                <div className='flex w-full'>
                  <span className='w-[50px] text-right mr-1'>Agent#:</span>
                  {displayName}
                </div>
                <span className='w-full h-[1px] border-t border-dashed border-black my-2'></span>

                <div className='flex '>
                  <div className='w-[65px]'>Game</div>
                  <div className='w-[35px]'>Nos</div>
                  <div className='w-[55px]'>Amt/Type</div>
                  <div className='w-[71px] text-right'>Win</div>
                </div>
                {bets.map((bet, index) => (
                  <div key={index} className='flex '>
                    <div className='w-[65px]'>
                      {bet.GameSetting?.otherSettings?.gameTicketLabel ||
                        bet.GameSetting?.name ||
                        bet.gameName ||
                        ''}
                    </div>
                    <div className='w-[35px]'>{bet.combination}</div>
                    <div className='w-[55px] text-right'>
                      <span className='mr-1'>{bet.amount}</span>{' '}
                      {bet.bettingOption === 'ramble' ? 'R' : 'T'}
                    </div>
                    <div className='w-[71px] text-right'>
                      {bet.bettingOption === 'S/O'
                        ? 'S/O'
                        : Number(bet.winAmount).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                    </div>
                  </div>
                ))}

                <div className='flex font-semibold'>
                  <span className='w-[50px] text-right mr-1'>Total:</span>P
                  {transaction.totalAmount}
                </div>
              </div>
            </div>
            {/* QR Code */}
            <div className='flex'>
              <span className='w-[50px] text-right mr-1'>Printed:</span>
              {dayjs(transaction.bets[0].createdAt).format(
                'MMM DD, YYYY HH:mm:ss'
              )}
            </div>
            <span className='text-center'>NO TICKET, NO CLAIM</span>
            <span className='text-center'>
              Palihog ko og tago og amping sa <br /> ticket, para gaminton pag
              calin. <br />
              TICKET IS VALID FOR ONE (1) YEAR
            </span>
            <div className='flex justify-center my-2'>
              <QRCodeSVG value={transaction.id} width={80} height={80} />
            </div>
            <div className='flex flex-col justify-center items-center w-full leading-tight'>
              <span>07225-ffb18cc0f527</span>
              <span>v1.4.2s</span>
              <img src={magic3Logo} className=' h-[25px]' />
            </div>
          </div>
        </div>
        <div className='h-4'></div>
      </div>
    </div>
  );
}
